import React from "react";

import Icon from "#SRC/js/components/Icon";

class NodesPage extends React.Component {
  render() {
    return this.props.children;
  }
}

NodesPage.routeConfig = {
  label: "Nodes",
  icon: <Icon id="servers-inverse" size="small" family="product" />,
  matches: /^\/nodes/
};

module.exports = NodesPage;



// WEBPACK FOOTER //
// ./plugins/nodes/src/js/pages/NodesPage.js